/**
 * Cleans a string of study properties by removing any assignment to the specified parameter names
 * where their values equal 1 or 0.
 * 
 * @param otherProperties - The study properties string to clean
 * @param paramNames - Array of parameter names to remove from the properties string
 * @returns The cleaned properties string with specified parameters removed
 * 
 * @example
 * ```typescript
 * cleanOtherPropertiesValue(studyData.otherProperties, [RUN_RT_PRICE_SIM_FAST_MODE, RUN_RT_DETERMINISTIC_MODE])
 * ```
 * where RUN_RT_PRICE_SIM_FAST_MODE, RUN_RT_DETERMINISTIC_MODE are constants that define parameter names
 */
export function cleanOtherPropertiesValue(
    otherProperties: string,
    paramNames: string[]
): string {
    if (typeof otherProperties !== 'string') return otherProperties;
    const regex = new RegExp(
        `^(${paramNames.join('|')})\\s*=\\s*[01]$`,
        'i'
    );
    return otherProperties
        .split(/[\n]+/)
        .map((s) => s.trim())
        .filter((line) => line.length > 0 && !regex.test(line))
        .join('\n');
}
